import http from './http'

export async function getPrivacyPolicy() {
    return await http.get("/privacy-policy", {}).then(response => {
        if (response.status === 200) {
            return response
        }
    }).catch(() => console.error("개인 정보 처리 방침 정보를 얻는데 실패했습니다."))
}

export async function postPrivacyPolicy(request) {
    return await http.post("/admin/privacy-policy", JSON.stringify(request)).then(response => {
        if (response.status === 201) {
            return response
        }
    }).catch(() => console.error("개인 정보 처리 방침 업로드에 실패했습니다."))
}

export async function deletePrivacyPolicy(id) {
    return await http.delete("/privacy-policy", { params: { "id": id } }).then(response => {
        if (response.status === 200) {
            return response
        }
    }).catch(() => console.error("개인 정보 처리 방침 삭제하는데 실패했습니다."))
}